import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form/immutable';
import { connect } from 'react-redux';
import FormGroup from '../../../../../components/controls/FormGroup';
import InfoBox from '../../../../../components/InfoBox/InfoBox';
import InfoBoxRow from '../../../../../components/InfoBox/InfoBoxRow';
import { defaultFormProperties } from '../../../../../utilities/form';
import styles from './_paymentDetailsForm.module.scss';
import MuiButton from '../../../../../components/controls/MuiButton';
import paymentDetailsFormResources from './paymentDetailsFormResources';
import MonthlyDuesPaymentDetailsInfoBox from './MonthlyDuesPaymentDetailsInfoBox';
import Spinner from '../../../../../components/Spinner/Spinner';
import legalContractResources from '../legalContractResources';
import { getGroupMembership } from '../../../../GroupMemberships/GeneralInfo/groupMembershipsActions';
import { getCalculatedDues } from './paymentDetailsFormActions';
import selectors from './gmrPaymentDetailsFormSelectors';

function GMRPaymentDetailsForm({ submitting, onNextStep, onPrevStep, handleSubmit, formParams, getGroupMembership, getCalculatedDues, isLoading, monthlyDues, todaysPayment, monthlyReimbursements, requiredVisits }) {
    useEffect(() => {
        getGroupMembership(formParams.partnerID);
        getCalculatedDues(formParams.partnerID, formParams.agreementDate);
    }, [formParams.partnerID]);
    return (isLoading
        ? <Spinner />
        : <FormGroup onSubmit={handleSubmit(onNextStep)} name="payment-details-form">
            <div className="grid__row">
                <div className="col-md-6">
                    <MonthlyDuesPaymentDetailsInfoBox monthlyDues={monthlyDues} todaysPayment={todaysPayment} />
                </div>
                <div className="col-md-6">
                    <InfoBox bordered>
                        <InfoBoxRow label={paymentDetailsFormResources.labelMonthlyReimbursements} content={monthlyReimbursements} bottomborder contentposition="right" />
                        <span className={styles.description_text}>{paymentDetailsFormResources.captionPaymentAfterTwentyFifthOfEveryMonth}</span>
                        <InfoBoxRow label={paymentDetailsFormResources.labelRequiredVisits} content={requiredVisits} bottomborder contentposition="right" />
                    </InfoBox>
                </div>
            </div>
            <div className="grid__row">
                <MuiButton className="btn_new btn_new--blue"
                    disabled={submitting}
                    type="submit"
                >
                    {legalContractResources.linkButtonNextText}
                </MuiButton>
                <MuiButton className="btn_new btn_new--white"
                    onClick={onPrevStep}
                >
                    {legalContractResources.linkButtonPrevious}
                </MuiButton>
            </div>
        </FormGroup>
    );
}

GMRPaymentDetailsForm.propTypes = {
    submitting: PropTypes.bool.isRequired,
    onNextStep: PropTypes.func.isRequired,
    onPrevStep: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    formParams: PropTypes.object.isRequired,
    getGroupMembership: PropTypes.func.isRequired,
    getCalculatedDues: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    monthlyDues: PropTypes.string,
    todaysPayment: PropTypes.string,
    monthlyReimbursements: PropTypes.string,
    requiredVisits: PropTypes.number,
};

const mapDispatchToProps = {
    getGroupMembership,
    getCalculatedDues
};

const connectStateToProps = connect(selectors, mapDispatchToProps);

export default reduxForm({
    ...defaultFormProperties,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(connectStateToProps(GMRPaymentDetailsForm));
